import { useNavigate, useParams } from 'react-router-dom';
import '../App.css';

const ProjectDetail = ({ projects }) => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  
  const project = projects.find(p => {
    const path = p.path.split('/').pop();
    return path === projectId;
  });

  if (!project) {
    return (
      <div className="project-detail">
        <button className="back-button" onClick={() => navigate('/')}>
          ← Back to Projects
        </button>
        <h2>Project not found</h2>
      </div>
    );
  }

  return (
    <div className="project-detail">
      <button className="back-button" onClick={() => navigate('/')}>
        ← Back to Projects
      </button>
      
      <div className="project-detail-header">
        <div className="project-detail-title">
          <div className="file-number">FILE {project.fileNumber}</div>
          <h1>{project.title}</h1>
        </div>
        <div className={`project-status ${getStatusClass(project.status)}`}>
          {project.status}
        </div>
      </div>

      <div className="project-detail-content">
        <div className="project-detail-image-container">
          <img src={project.image} alt={project.title} className="project-detail-image" />
        </div>
        
        <div className="project-detail-info">
          <div className="project-detail-date">
            <h3>Project Date</h3>
            <p>{project.date}</p>
          </div>
          
          <div className="project-detail-description">
            <h3>About the Project</h3>
            <p>{project.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const getStatusClass = (status) => {
  switch (status.toLowerCase()) {
    case 'ongoing':
      return 'status-ongoing';
    case 'completed':
      return 'status-completed';
    case 'pending':
      return 'status-pending';
    default:
      return 'status-ongoing';
  }
};

export default ProjectDetail; 